import { render, staticRenderFns } from "./login-page.vue?vue&type=template&id=9cbdb0ca&scoped=true"
import script from "./login-page.vue?vue&type=script&lang=js"
export * from "./login-page.vue?vue&type=script&lang=js"
import style0 from "./login-page.vue?vue&type=style&index=0&id=9cbdb0ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cbdb0ca",
  null
  
)

export default component.exports